import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class OrganisationApiService extends ApiService {
  static async getSubscriptionDetails(): Promise<IServiceResponse<object>> {
    return this.axios.get('billing/subscription')
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async submitInvoiceDetails(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('billing/invoice-details', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async addPaymentMethod(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('billing/add-payment-method', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getInvoices(): Promise<IServiceResponse<object>> {
    return this.axios.get('billing/invoices')
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
